class HomeCommentGallery extends HTMLElement {
  constructor() {
    super()
    this.handleClick = this.handleClick.bind(this)
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick)

    // modal-container 会移到 body，section 卸载时需同步清理所属弹窗。
    document.querySelectorAll('[data-comment-gallery-owner]').forEach(modal => {
      if (modal.dataset.commentGalleryOwner === this.dataset.sectionId) modal.remove()
    })
  }

  handleClick(event) {
    if (!(event.target instanceof Element)) return

    // 产品链接保持原有跳转行为，不触发评论弹窗。
    if (event.target.closest('a')) return

    // 真实控件（缩略图 / 查看详情）优先，并阻止冒泡到外层卡片委托。
    const control = event.target.closest('button[data-comment-gallery-open]')
    if (control && this.contains(control)) {
      event.stopPropagation()
      this.openModal(control, control.dataset.imageIndex)
      return
    }

    // 鼠标点击整卡委托：仅外层卡片承载 data-comment-gallery-open。
    const opener = event.target.closest('[data-comment-gallery-open]')
    if (!opener || !this.contains(opener)) return

    const imageIndex = event.target.closest('[data-image-index]')?.dataset.imageIndex
    this.openModal(opener, imageIndex)
  }

  openModal(opener, imageIndex) {
    const modal = document.getElementById(opener.dataset.commentGalleryOpen)
    if (!modal) return

    this.setupModal(modal)
    // 图片索引来自被点击的缩略图或卡片默认值；产品类型弹窗无需执行图片切换。
    const activeImageIndex = imageIndex || opener.dataset.imageIndex
    if (activeImageIndex) this.setActiveImage(modal, activeImageIndex)
    modal.show(opener)

    requestAnimationFrame(() => {
      // 移动端隐藏轮播缩略图，因此将焦点放在关闭按钮上。
      if (window.matchMedia('(max-width: 767px)').matches) {
        modal.querySelector('[id^="ModalClose-"]')?.focus()
        return
      }

      const activeThumbnail = modal.querySelector('[data-comment-gallery-thumbnail].is-active')
      if (activeThumbnail) {
        activeThumbnail.focus()
        return
      }

      modal.querySelector('.home-comment-gallery-modal_close--desktop')?.focus()
    })
  }

  setupModal(modal) {
    if (modal.dataset.galleryBound === 'true') return

    // modal-container 会移动到 body，弹窗内部事件需独立绑定且只绑定一次。
    modal.dataset.galleryBound = 'true'
    modal.addEventListener('click', event => {
      const closeButton = event.target.closest('[data-comment-gallery-close]')
      if (closeButton) {
        modal.hide()
        return
      }

      const thumbnail = event.target.closest('[data-comment-gallery-thumbnail]')
      if (thumbnail) {
        this.setActiveImage(modal, thumbnail.dataset.imageIndex)
        return
      }

      const navigation = event.target.closest('[data-comment-gallery-navigation]')
      if (navigation) this.showAdjacentImage(modal, Number(navigation.dataset.commentGalleryNavigation))
    })

    modal.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') this.showAdjacentImage(modal, -1)
      if (event.key === 'ArrowRight') this.showAdjacentImage(modal, 1)
    })

    modal.addEventListener('modal:show', () => document.body.classList.add('overflow-hidden'))
    modal.addEventListener('modal:hide', () => {
      document.body.classList.remove('overflow-hidden')
      modal.openedBy?.focus()
    })
  }

  setActiveImage(modal, imageIndex) {
    modal.querySelectorAll('[data-comment-gallery-image]').forEach(image => {
      image.hidden = image.dataset.imageIndex !== imageIndex
    })

    modal.querySelectorAll('[data-comment-gallery-thumbnail]').forEach(thumbnail => {
      const isActive = thumbnail.dataset.imageIndex === imageIndex
      thumbnail.classList.toggle('is-active', isActive)
      thumbnail.setAttribute('aria-pressed', String(isActive))
    })

    modal.dataset.activeImageIndex = imageIndex
  }

  showAdjacentImage(modal, direction) {
    const thumbnails = [...modal.querySelectorAll('[data-comment-gallery-thumbnail]')]
    if (thumbnails.length < 2) return

    const activeIndex = thumbnails.findIndex(thumbnail => thumbnail.classList.contains('is-active'))
    const nextIndex = (activeIndex + direction + thumbnails.length) % thumbnails.length
    const nextThumbnail = thumbnails[nextIndex]

    this.setActiveImage(modal, nextThumbnail.dataset.imageIndex)
    nextThumbnail.focus()
  }
}

if (!customElements.get('home-comment-gallery')) {
  customElements.define('home-comment-gallery', HomeCommentGallery)
}
